import { KatButton } from '@amzn/katal-react';
import { LocaleSelector } from './LocaleSelector';
import { PlacementSelector } from './PlacementSelector';
import { useSmartUpload, AppMode } from 'src/contexts/SmartUploadContext';
import styles from './SelectSection.module.css';

const SelectSection = () => {
  const { mode, setMode, resetSmartUpload } = useSmartUpload();

  const handleModeChange = (newMode: AppMode) => {
    if (newMode === mode) return;
    setMode(newMode);
    if (newMode === 'smart') resetSmartUpload();
  };

  return (
    <section className={styles.container}>
      {mode === 'standard' && (
        <div className={styles.selectors}>
          <PlacementSelector />
          <LocaleSelector />
        </div>
      )}
      <div className={styles.modeToggle}>
        <KatButton
          variant={mode === 'standard' ? 'primary' : 'secondary'}
          onClick={() => handleModeChange('standard')}
        >
          Standard
        </KatButton>
        <KatButton
          variant={mode === 'smart' ? 'primary' : 'secondary'}
          onClick={() => handleModeChange('smart')}
        >
          Smart Upload
        </KatButton>
      </div>
    </section>
  );
};

export { SelectSection };
